<template>
    <l-map
        :center="center"
        :options="options"
        :zoom="zoom"
        ref="map"
    >
        <slot />
    </l-map>
</template>

<script>
// Components.
import { LMap } from "vue2-leaflet"

// Others.
import L from 'leaflet'

// Styles.
import 'leaflet/dist/leaflet.css'

export default {
    components: { LMap },
    created() {
        delete L.Icon.Default.prototype._getIconUrl

        L.Icon.Default.mergeOptions({
            iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
            iconUrl: require('leaflet/dist/images/marker-icon.png'),
            shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        })
    },
    data: () => ({
        map: null,
        bounds: null,
    }),
    methods: {
        getMapObject() {
            return this.$refs.map.mapObject
        },
    },
    props: {
        center: { type: [Array, Object] },
        options: { type: Object },
        zoom: { type: Number, default: 12 },
    },
}
</script>